<template>
  <div class="shop-sets-wrapper">
    <div class="shop-sets">
      <div class="shop-sets__header">
        <h2 class="m-0">{{ $t('selectx', { x: $tc('shopSet').toLowerCase() }) }}:</h2>
        <ButtonComponent
          :label="$t('manualSelectAndSkip')"
          :icon="['fal', 'angle-right']"
          @click="$emit('select')"
        />
      </div>
      <Card
        v-for="set in value.sets"
        :key="set.id"
        :value="set"
        :shop="value"
        @select="$ev => $emit('select', $ev)"
        @open:modal="$ev => $emit('open:modal', $ev)"
      />
    </div>
  </div>
</template>

<script>
import Card from './Card'

export default {
  props: {
    value: Object,
  },
  components: {
    Card,
  },
}
</script>

<style lang="scss">
.shop-sets {
  max-width: 1250px;
  width: 100%;
  margin: 0 auto;
  padding: 4rem 2rem;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 762px) {
    padding: 2rem 0 0 0;

    &__header {
      text-align: center;
      flex-direction: column;
      align-items: center;
    }
  }

  &__header {
    gap: 1rem;

    display: flex;
    justify-content: space-between;
  }

  .shop-set-card {
    & + .shop-set-card {
      margin-top: 1rem;
    }
  }

  & > label {
    display: block;
    text-align: center;
    font-size: 1.2rem;
  }

  &-wrapper {
    background-color: darken(white, 3%);
  }
}
</style>
